export default "__VITE_ASSET__DgnEf7Pd__"